/** Format a dollar amount, e.g. 1234.5 → "$1,234.5", -120 → "-$120". */
export function money(n: number): string {
  const sign = n < 0 ? "-" : "";
  return `${sign}$${Math.abs(n).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
}
